import { mutatorAction } from 'satcheljs';
import { PopupType } from '../store/schema/enums/PopupType';
import { getAppStore } from '../store/store';

export const onPopupOpenChanged = mutatorAction('onPopupOpenChanged', (openedPopup: PopupType) => {
  getAppStore().openedPopup = openedPopup;
});